import styled from 'styled-components';
import Variables from "../../../../../../../assets/styleVariables";

export const TermsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${Variables.colors.complementary_900};
  font-size: ${Variables.font_sizes.medium};
`;